export const deliveryAddress = {
  itemType: "input",
  required: false,
  data: {
    id: "deliveryAddress",
    label: "",
    placeholder: "",
    value: "",
    otherInfo: "",
  },
};

export const deliveryTimeOptions = {
  itemType: "radio",
  required: false,
  data: {
    id: "deliveryTime",
    label: "",
    placeholder: "",
    value: "",
    otherInfo: "",
    options: [
      {
        label: "預約配送",
        value: "1",
      },
      {
        label: "立即配送",
        value: "2",
      },
    ],
  },
};
export const phoneNumber = {
  itemType: "input",
  required: false,
  data: {
    id: "phoneNumber",
    label: "",
    placeholder: "",
    value: "",
    otherInfo: "",
  },
};

export const invoice = {
  itemType: "radio",
  required: false,
  data: {
    id: "invoice_type",
    label: "",
    placeholder: "",
    value: "1",
    otherInfo: "",
    options: [
      {
        label: "載具",
        value: "carrier",
      },
      {
        label: "統編",
        value: "tax_id",
      },
      {
        label: "其他",
        value: "other",
      },
      // 捐贈選項暫時隱藏（發票捐贈功能尚未生效）：
      // {
      //   label: "捐贈",
      //   value: "donate",
      // },
    ],
  },
};

export const taxIdNumber = {
  itemType: "input",
  required: false,
  data: {
    id: "taxIdNumber",
    label: "",
    placeholder: "請輸入 8 位數統編",
    value: "",
    otherInfo: "",
  },
};

export const invoiceCarrier = {
  itemType: "input",
  required: false,
  data: {
    id: "invoiceCarrier",
    label: "",
    placeholder: "例：/ABC1234（/ 開頭共 8 碼）",
    value: "",
    otherInfo: "",
  },
};
